module.exports = function getResource(label, vars = []) {
    const resources = {
        autoReplenishTitle: `Auto-Replenish (${vars[0]})`,
        changeMethod: 'Change Method',
        free: 'FREE'
    };

    return resources[label];
};
